/* PURPLE LEGACY - Urlaubs-/Versandhinweis 2026
 * 1) Blendet oben einen Urlaubsbanner ein.
 * 2) Entschaerft die "1-2 Tage DHL Versand"-Versprechen zur Laufzeit.
 *
 * WICHTIG: Aendert NICHTS dauerhaft am Theme. Ab END_DATE ist automatisch
 * wieder alles im Originalzustand - kein manueller Rueckbau noetig.
 *
 * Die Hero-Ueberschrift (h2.banner__heading) bleibt bewusst unangetastet,
 * weil dort das SEO-Keyword sitzt.
 *
 * Vorschau vor Go-Live: ?plpreview=1 an die URL haengen.
 */
(function () {
  if (window.__plUrlaub) return;
  window.__plUrlaub = true;

  var LIVE = true;                          // auf true = oeffentlich sichtbar
  var END_DATE = new Date('2026-08-01T00:00:00+02:00');
  var PREVIEW = location.search.indexOf('plpreview=1') !== -1;

  if (!PREVIEW) {
    if (!LIVE) return;
    if (new Date() >= END_DATE) return;      // Urlaub vorbei -> alles wie vorher
  }

  /* ---------- 1. Banner ---------- */

  var CSS = [
    '.pl-urlaub{position:sticky;top:0;z-index:9999;width:100%;',
    'background:linear-gradient(100deg,#2E0B4F 0%,#5B1E9E 55%,#8E2FC4 100%);',
    'color:#fff;font-family:Inter,system-ui,-apple-system,Segoe UI,sans-serif;',
    'box-shadow:0 2px 18px rgba(0,0,0,.45);border-bottom:2px solid #E040A0;}',
    '.pl-urlaub__in{max-width:1200px;margin:0 auto;padding:16px 20px;display:flex;',
    'align-items:center;justify-content:center;gap:16px;text-align:center;}',
    '.pl-urlaub__icon{font-size:30px;line-height:1;flex:0 0 auto;}',
    '.pl-urlaub__txt{display:flex;flex-direction:column;gap:3px;}',
    '.pl-urlaub__h{font-size:19px;font-weight:800;letter-spacing:.4px;text-transform:uppercase;}',
    '.pl-urlaub__h em{font-style:normal;color:#FFC9EC;}',
    '.pl-urlaub__s{font-size:15px;font-weight:500;opacity:.95;}',
    '.pl-urlaub__s b{color:#FFC9EC;font-weight:800;}',
    '@media(max-width:700px){',
    '.pl-urlaub__in{padding:12px 14px;gap:10px;}',
    '.pl-urlaub__icon{font-size:24px;}',
    '.pl-urlaub__h{font-size:15px;}',
    '.pl-urlaub__s{font-size:13px;}}'
  ].join('');

  function mountBanner() {
    if (document.querySelector('.pl-urlaub')) return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var bar = document.createElement('div');
    bar.className = 'pl-urlaub';
    bar.setAttribute('role', 'status');

    var inner = document.createElement('div');
    inner.className = 'pl-urlaub__in';

    var icon = document.createElement('div');
    icon.className = 'pl-urlaub__icon';
    icon.textContent = '🌴';

    var txt = document.createElement('div');
    txt.className = 'pl-urlaub__txt';

    var h = document.createElement('div');
    h.className = 'pl-urlaub__h';
    h.innerHTML = 'Urlaubspause – <em>Bestellen geht weiter!</em>';

    var s = document.createElement('div');
    s.className = 'pl-urlaub__s';
    s.innerHTML = 'Du kannst ganz normal bestellen. Der Versand aller Bestellungen erfolgt ab dem <b>1. August 2026</b>.';

    txt.appendChild(h);
    txt.appendChild(s);
    inner.appendChild(icon);
    inner.appendChild(txt);
    bar.appendChild(inner);

    document.body.insertBefore(bar, document.body.firstChild);
  }

  /* ---------- 2. Versandversprechen entschaerfen ---------- */

  var RULES = [
    ['🚀 1-2 Tage DHL Versand',            '🌴 Versand ab 01.08.2026'],
    ['🚚 1-2 Tage DHL Versand',            '🌴 Versand ab 01.08.2026'],
    ['1-2 Tage DHL Versand',               'Versand ab 01.08.2026'],
    ['Kostenloser DHL Versand ab 29,99€',  'Versand ab 01.08.2026 – kostenlos ab 29,99€']
  ];

  function skip(el) {
    if (!el) return true;
    var tag = el.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return true;
    if (el.closest('.pl-urlaub')) return true;
    if (el.closest('.banner__heading')) return true;   // SEO-Ueberschrift schuetzen
    return false;
  }

  function patchTexts(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n, todo = [];
    while ((n = w.nextNode())) {
      if (skip(n.parentElement)) continue;
      var v = n.nodeValue;
      if (v.indexOf('1-2 Tage DHL Versand') === -1 &&
          v.indexOf('Kostenloser DHL Versand') === -1) continue;
      todo.push(n);
    }
    todo.forEach(function (node) {
      var v = node.nodeValue;
      RULES.forEach(function (r) {
        v = v.split(r[0]).join(r[1]);
      });
      if (v !== node.nodeValue) node.nodeValue = v;
    });
    return todo.length;
  }

  /* ---------- Start ---------- */

  function run() {
    mountBanner();
    patchTexts(document.body);
  }

  function boot() {
    run();
    // Sections koennen nachrendern (Theme-Editor, Cart-Drawer, Apps)
    var t = null;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { patchTexts(document.body); }, 120);
    });
    obs.observe(document.body, {childList: true, subtree: true});
  }

  if (document.body) {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
